module.exports = __webpack_public_path__ + "img/03mazda-3.c32c99ad.png";